export default "__VITE_ASSET__6983db8a__"